<template>
	<div>
		<TitleSection>
			<template #h1>
				Software mit Wirkung
			</template>
			<template #h2>
				Intelligente Produkte für reale Herausforderungen.
			</template>
		</TitleSection>
		<NuxtLayout name="slider">
			<VerticalSplitSection>
				<template #left>
					<h3>IP-Trace</h3>
					<div>
						<p>
							Bei ip-trace.de haben wir es uns zur Aufgabe gemacht, digitale Schnittstellen intelligenter, sicherer und lokalisierbarer zu machen. Als spezialisierter Anbieter für IP-Geolocation und Netzwerk-Analyse bieten wir Entwicklern, Unternehmen und IT-Sicherheitsexperten hochpräzise Echtzeit-Daten zu IP-Adressen. Egal ob es um den Schutz vor Betrug, die Personalisierung von Nutzererfahrungen oder die Optimierung von Content-Delivery-Netzwerken geht – unsere Infrastruktur liefert die notwendigen Einblicke sekundenschnell.
						</p>
						<p>
							Unsere Plattform verarbeitet täglich Millionen von Abfragen und greift dabei auf kontinuierlich aktualisierte Datenbanken zurück. Dadurch garantieren wir eine außerordentlich hohe Abdeckungs- und Genauigkeitsrate für weltweite IP-Standorte, Internetdienstanbieter (ISPs) und Anonymisierungsdienste wie VPNs oder Proxies. Wir wissen, dass Geschwindigkeit und Zuverlässigkeit in der heutigen IT-Landschaft entscheidend sind. Deshalb ist unsere API auf minimale Latenzzeiten und maximale Ausfallsicherheit ausgelegt.
						</p>
						<p>
							<NuxtLink href="https://ip-trace.de" target="_blank" aria-label="Zu ip-trace.de">Zu ip-trace.de</NuxtLink>
						</p>
					</div>
				</template>
				<template #right>
					<img src="~/assets/media/i/ip-trace.webp" alt="IP-Trace.de" width="500" height="750" />
				</template>
			</VerticalSplitSection>
			<VerticalSplitSection>
				<template #left>
					<h3>BPM-System</h3>
					<div>
						<p>
							Unsere BPM-Betriebssoftware ermöglicht eine vollautomatisierte Erfassung und Verwaltung von Prozessen und Ressourcen mithilfe moderner, digitaler Schnittstellen. Als reines Prozess-Backend übernimmt sie die zentrale Datenverarbeitung als auch modular gesteuerte Auswertung. Wichtige Ereignisse oder Vorgänge werden bei ihrem Start und Abschluss erkannt und erfasst, wodurch die genaue Dauer und der Umfang der Nutzung präzise dokumentiert werden – ganz ohne manuelle Eingabe, Tickets oder zusätzliche analoge Geräte.
						</p>
						<p>
							Die Lösung verarbeitet alle Daten in Echtzeit, ermöglicht eine nahtlose, digitale Abrechnung der entstandenen Kosten oder Gebühren und integriert sich unkompliziert in bestehende Verwaltungsprozesse. Durch eine großzügige Auswahl an Schnittstellen, lässt sich die Software mit beinahe jedem Gerät koppeln. Sie wurde streng nach geltenden EU-Gesetzen und den Richtlinien der DSGVO entwickelt, um höchsten Datenschutz und rechtliche Sicherheit zu gewährleisten.
						</p>
						<p>
							Nutzer profitieren von einem einfachen und schnellen Ablauf ihrer Vorgänge, während Betreiber durch transparente Auswertungen, optimierte Auslastung und reduzierten Aufwand bei Kontrolle und Abrechnung entlastet werden. Zusätzlich bietet das System Module für weitere Services wie Kundenbindung, Reservierungen oder dynamische Preismodelle, so lässt sich das Produkt für jeden Kunden maßanfertigen.
						</p>
					</div>
				</template>
				<template #right>
					<img src="~/assets/media/i/backend.webp" alt="BPM-Betriebssystem" width="500" height="750" />
				</template>
			</VerticalSplitSection>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Projekte',
	ogTitle: 'Projekte: Mailuft',
	twitterTitle: 'Projekte: Mailuft',
	ogDescription: 'Lassen Sie sich inspirieren: Unser Portfolio zeigt innovative Lösungen und maßgeschneiderte Projekte. Erfahren Sie, wie wir Herausforderungen meistern.',
	description: 'Lassen Sie sich inspirieren: Unser Portfolio zeigt innovative Lösungen und maßgeschneiderte Projekte. Erfahren Sie, wie wir Herausforderungen meistern.',
	twitterDescription: 'Lassen Sie sich inspirieren: Unser Portfolio zeigt innovative Lösungen und maßgeschneiderte Projekte. Erfahren Sie, wie wir Herausforderungen meistern.',
})

definePageMeta({
	layout: 'slider',
})
</script>